import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=045aeeba"
import script from "./radio-group.vue?vue&type=script&lang=ts"
export * from "./radio-group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports